webpackJsonp([78],{

/***/ 1316:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1317);


/***/ }),

/***/ 1317:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(169);

var _datetime2 = _interopRequireDefault(_datetime);

var _en = __webpack_require__(795);

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en', _en2.default);

/***/ })

},[1316]);


// WEBPACK FOOTER //
// app/datetime.en-90a81397b0c31ee06334.js